import exportimages from "../assets/images/exportImages";

export const PRODUCT_OPPORTUNITIES = [
  {
    key: "credit_card",
    // name: "Credit Card",
    icon: exportimages.icon_credit_card,
    color: "#27CAE3",
  },
  {
    key: "consumer_loan",
    // name: "Consumer Loan",
    icon: exportimages.icon_consumer_loan,
    color: "#5CAEFF",
  },
  {
    key: "mortgage",
    // name: "Mortgage",
    icon: exportimages.icon_mortgage,
    color: "#FE6682",
  },
  {
    key: "auto_loan",
    // name: "Auto Loan",
    icon: exportimages.icon_auto_loan,
    color: "#6C7DE5",
  },
  {
    key: "student_loan",
    // name: "Student Loan",
    icon: exportimages.icon_student_loan,
    color: "#FF6DE8",
  },
  {
    key: "personal_loan",
    // name: "Personal Loan",
    icon: exportimages.icon_personal_loan,
    color: "#FFB30E",
  },
  {
    key: "business_loan",
    // name: "Business Loan",
    icon: exportimages.icon_business_loan,
    color: "#A099F3",
  },
  {
    key: "commercial_loan",
    // name: "Commercial Loan",
    icon: exportimages.icon_commercial_loan,
    color: "#3EE0D7",
  },
  {
    key: "deposit",
    // name: "Deposit",
    icon: exportimages.icon_deposit,
    color: "#A099F3",
  },
  {
    key: "checking",
    name: "Checking Account",
    icon: exportimages.icon_checking,
    color: "#8577E6",
  },
  {
    key: "line_of_credit",
    // name: "Line of Credit",
    icon: exportimages.icon_line_of_credit,
    color: "#39D191",
  },
  {
    key: "term_loan",
    // name: "Term Loan",
    icon: exportimages.icon_term_loan,
    color: "#4AC8F5",
  },
  {
    key: "trade_finance",
    // name: "Trade Finance",
    icon: exportimages.icon_trade_finance,
    color: "#D18FF4",
  },
  {
    key: "p_card",
    // name: "P Card",
    icon: exportimages.icon_p_card,
    color: "#9B7BEB",
  },
  {
    key: "real_estate_loan",
    // name: "Real Estate Loan",
    icon: exportimages.icon_real_estate_loan,
    color: "#F07290",
  },
  {
    key: "corporate_card",
    // name: "Corporate Card",
    icon: exportimages.icon_corporate_card,
    color: "#EE8458",
  },
  {
    key: "certificates_of_deposit",
    // name: "Certificates of Deposit (CDs)",
    icon: exportimages.icon_certificates_of_deposit,
    // coloured_icon: exportimages.icon_certificates_of_deposit_coloured,
    color: "#56E3D3",
  },
  {
    key: "commercial_loan_payments_others",
    // name: "Certificates of Deposit (CDs)",
    icon: exportimages.icon_commercial_loan_payments_others,
    // coloured_icon: exportimages.icon_certificates_of_deposit_coloured,
    color: "#FDAC34",
  },
];

export const CONSUMERS_TYPES = [
  {
    key: "account_transfer",
    // name: "Account Transfer",
    icon: exportimages.icon_account_transfer,
    coloured_icon: exportimages.icon_account_transfer_coloured,
    color: "#1570EF",
  },
  {
    key: "checking",
    name: "Checking Account",
    icon: exportimages.icon_checking,
    coloured_icon: exportimages.icon_checking_coloured,
    color: "#8577E6",
  },
  {
    key: "savings",
    name: "Savings Account",
    icon: exportimages.icon_savings,
    coloured_icon: exportimages.icon_savings_coloured,
    color: "#EA80AE",
  },
  {
    key: "certificates_of_deposit",
    // name: "Certificates of Deposit (CDs)",
    icon: exportimages.icon_certificates_of_deposit,
    coloured_icon: exportimages.icon_certificates_of_deposit_coloured,
    color: "#56E3D3",
  },
  {
    key: "ira",
    name: "IRA",
    icon: exportimages.icon_ira,
    coloured_icon: exportimages.icon_ira_coloured,
    color: "#FFD77A",
  },
  {
    key: "health_savings_account",
    // name: "Health Savings Account (HSA)",
    icon: exportimages.icon_health_savings_account,
    coloured_icon: exportimages.icon_health_savings_account_coloured,
    color: "#67A1E7",
  },
  {
    key: "529_education_accounts",
    name: "529 Education Account",
    icon: exportimages.icon_529_education_accounts,
    coloured_icon: exportimages.icon_529_education_accounts_coloured,
    color: "#B48DF2",
  },
  {
    key: "investment",
    // name: "Investments",
    icon: exportimages.icon_investment,
    coloured_icon: exportimages.icon_investment_coloured,
    color: "#F79268",
  },
  {
    key: "commercial_investment",
    // name: "Investments",
    icon: exportimages.icon_commercial_investment,
    coloured_icon: exportimages.icon_commercial_investment_coloured,
    color: "#FF8080",
  },
  {
    key: "general_transfer",
    // name: "General Transfer",
    icon: exportimages.icon_general_transfer,
    coloured_icon: exportimages.icon_general_transfer_coloured,
    color: "#45BE8B",
  },
  {
    key: "person_to_person",
    // name: "Person to Person",
    icon: exportimages.icon_person_to_person,
    coloured_icon: exportimages.icon_person_to_person_coloured,
    color: "#be56d6",
  },
  {
    key: "checking_account",
    // name: "Checking account",
    icon: exportimages.icon_checking,
    coloured_icon: exportimages.icon_checking_coloured,
    color: "#8577E6",
  },
  {
    key: "short_term_investment_solutions",
    // name: "Short-term Investment Solutions ",
    icon: exportimages.icon_short_term_investment_solutions,
    coloured_icon: exportimages.icon_short_term_investment_solutions_coloured,
    color: "#F07290",
  },
  {
    key: "zero_balance_account",
    // name: "Zero Balance Account",
    icon: exportimages.icon_zero_balance_account,
    coloured_icon: exportimages.icon_zero_balance_account_coloured,
    color: "#52C796",
  },
  {
    key: "operating_checking_account",
    // name: "Operating Checking Account",
    icon: exportimages.icon_operating_checking_account,
    coloured_icon: exportimages.icon_operating_checking_account_coloured,
    color: "#0FD8C1",
  },
  {
    key: "business_savings_account",
    // name: "Business Savings Account",
    icon: exportimages.icon_business_savings_account,
    coloured_icon: exportimages.icon_business_savings_account_coloured,
    color: "#F5723D",
  },
  {
    key: "remote_deposit_capture",
    // name: "Remote Deposit Capture",
    icon: exportimages.icon_remote_deposit_capture,
    coloured_icon: exportimages.icon_remote_deposit_capture_coloured,
    color: "#D495F5",
  },
  {
    key: "sweep_account",
    // name: "Sweeps",
    icon: exportimages.icon_sweep_account,
    coloured_icon: exportimages.icon_sweep_account_coloured,
    color: "#F37AAF",
  },
  {
    key: "money_market_account",
    // name: "Money Market Account",
    icon: exportimages.icon_money_market_account,
    coloured_icon: exportimages.icon_money_market_account_coloured,
    color: "#8576F0",
  },
  {
    key: "business_checking_account",
    // name: "Business Checking Account",
    icon: exportimages.icon_business_checking_account,
    coloured_icon: exportimages.icon_business_checking_account_coloured,
    color: "#FDAC34",
  },
  {
    key: "external_bank_transfers",
    // name: "External Bank Transfers",
    icon: exportimages.icon_external_bank_transfers,
    coloured_icon: exportimages.icon_external_bank_transfers_coloured,
    color: "#5D9AC6",
  },
];
